import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { UserRoleAssignmentRequest } from '../types/role.types';

/**
 * Wraps `/auth/api/admin/users/...` (Keycloak-backed user/role assignment).
 * `userIdentifier` may be a username, email, or Keycloak UUID — username is
 * the safest choice and what the admin app uses.
 */
@Injectable({ providedIn: 'root' })
export class UserRolesService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.gatewayUrl}/auth/api/admin/users`;

  /** Returns the role names currently assigned to the user (`ROLE_*` prefixed). */
  list(userIdentifier: string): Observable<string[]> {
    return this.http.get<string[]>(
      `${this.base}/${encodeURIComponent(userIdentifier)}/roles`,
    );
  }

  assign(req: UserRoleAssignmentRequest): Observable<void> {
    return this.http.post<void>(`${this.base}/roles/assign`, req);
  }

  remove(req: UserRoleAssignmentRequest): Observable<void> {
    return this.http.post<void>(`${this.base}/roles/remove`, req);
  }
}
